import { z } from 'zod';
import { vaultQueueJobSchema } from '../fetchQueue/fetch-queue-response';
import { queuePoolSchema, queueStatsSchema } from '../queueShared';

export const fetchUploadStatusResponseSchema = z.object({
  pool: queuePoolSchema,
  stats: queueStatsSchema,
  jobs: z.array(vaultQueueJobSchema),
});

export type IFetchUploadStatusResponse = z.infer<typeof fetchUploadStatusResponseSchema>;
